// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chips__TrigWidget-module--dOdUn {
    display: flex;
    align-items: center;
    gap: calc(var(--px) * 6);
}

.chipActive__TrigWidget-module--GidfU,
.chipInactive__TrigWidget-module--s_Bxf {
    display: flex;
    align-items: center;
    gap: calc(var(--px) * 6);
    padding: calc(var(--px) * 4) calc(var(--px) * 10);
    border-radius: 999px;
    font-size: calc(var(--px) * 12);
    font-weight: 700;
    white-space: nowrap;
}

.chipActive__TrigWidget-module--GidfU {
    background: #FDE8D6;
    color: #7A3A06;
}

.chipInactive__TrigWidget-module--s_Bxf {
    background: var(--color-neutral-100);
    color: var(--color-neutral-600);
    font-weight: 600;
}

.chipDot__TrigWidget-module--rKm2d {
    width: calc(var(--px) * 8);
    height: calc(var(--px) * 8);
    border-radius: 50%;
    background: var(--home-color-orange);
}

.plot__TrigWidget-module--bbg3Z {
    position: relative;
    width: calc(var(--px) * 300);
    height: calc(var(--px) * 150);
}

.svg__TrigWidget-module--yKN3B {
    position: absolute;
    inset: 0;
    display: block;
    width: calc(var(--px) * 300);
    height: calc(var(--px) * 150);
}

.axisLabel__TrigWidget-module--R5tZg {
    font-size: calc(var(--px) * 10);
    font-weight: 600;
}

.revealRect__TrigWidget-module--yFikt {
    transform: scaleX(1);
    transform-origin: 80px 0;
}

.revealRect__TrigWidget-module--yFikt.animated__TrigWidget-module--hB9KE {
    animation: reveal__TrigWidget-module--E9y0L 8s linear infinite;
}

@keyframes reveal__TrigWidget-module--E9y0L {
    from {
        transform: scaleX(0);
    }
    to {
        transform: scaleX(1);
    }
}

.radiusGroup__TrigWidget-module--V6dZc {
    transform-origin: 36px 75px;
    transform: rotate(0deg);
}

.radiusGroup__TrigWidget-module--V6dZc.animated__TrigWidget-module--hB9KE {
    animation: spin__TrigWidget-module--bc_eG 8s linear infinite reverse;
}

@keyframes spin__TrigWidget-module--bc_eG {
    to {
        transform: rotate(360deg);
    }
}

.tracerTrack__TrigWidget-module--tqAir {
    position: absolute;
    left: 0;
    top: calc(var(--px) * 75);
    width: calc(var(--px) * 300);
    height: 0;
    transform: translateY(0);
}

.tracerTrack__TrigWidget-module--tqAir.animated__TrigWidget-module--hB9KE {
    animation: sy__TrigWidget-module--sfTEK 8s infinite;
}

@keyframes sy__TrigWidget-module--sfTEK {
    0% {
        transform: translateY(0);
        animation-timing-function: cubic-bezier(.61, 1, .88, 1);
    }
    25% {
        transform: translateY(calc(var(--px) * -30));
        animation-timing-function: cubic-bezier(.12, 0, .39, 0);
    }
    50% {
        transform: translateY(0);
        animation-timing-function: cubic-bezier(.61, 1, .88, 1);
    }
    75% {
        transform: translateY(calc(var(--px) * 30));
        animation-timing-function: cubic-bezier(.12, 0, .39, 0);
    }
    100% {
        transform: translateY(0);
    }
}

.guide__TrigWidget-module--lbO7a {
    position: absolute;
    left: calc(var(--px) * 36);
    top: -1px;
    width: calc(var(--px) * 254);
    border-top: 1.5px dashed var(--color-neutral-400);
}

.tracerDot__TrigWidget-module--PxJef {
    position: absolute;
    left: calc(var(--px) * -6);
    top: calc(var(--px) * -6);
    width: calc(var(--px) * 12);
    height: calc(var(--px) * 12);
    border-radius: 50%;
    background: var(--home-color-orange);
    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);
    transform: translateX(calc(var(--px) * 290));
}

.tracerDot__TrigWidget-module--PxJef.animated__TrigWidget-module--hB9KE {
    animation: sx__TrigWidget-module--KVGLg 8s linear infinite;
}

@keyframes sx__TrigWidget-module--KVGLg {
    from {
        transform: translateX(calc(var(--px) * 80));
    }
    to {
        transform: translateX(calc(var(--px) * 290));
    }
}

.caption__TrigWidget-module--IX_pt {
    font-size: calc(var(--px) * 13);
    font-weight: 600;
    color: var(--color-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/TrigWidget.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,iDAAiD;IACjD,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,8DAAoC;AACxC;;AAEA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,oEAA0C;AAC9C;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,yBAAyB;IACzB,4BAA4B;IAC5B,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,mDAAyB;AAC7B;;AAEA;IACI;QACI,wBAAwB;QACxB,uDAAuD;IAC3D;IACA;QACI,4CAA4C;QAC5C,uDAAuD;IAC3D;IACA;QACI,wBAAwB;QACxB,uDAAuD;IAC3D;IACA;QACI,2CAA2C;QAC3C,uDAAuD;IAC3D;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,SAAS;IACT,4BAA4B;IAC5B,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,oCAAoC;IACpC,4DAA4D;IAC5D,4CAA4C;AAChD;;AAEA;IACI,0DAAgC;AACpC;;AAEA;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,kCAAkC;AACtC","sourcesContent":[".chips {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--px) * 6);\n}\n\n.chipActive,\n.chipInactive {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--px) * 6);\n    padding: calc(var(--px) * 4) calc(var(--px) * 10);\n    border-radius: 999px;\n    font-size: calc(var(--px) * 12);\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n.chipActive {\n    background: #FDE8D6;\n    color: #7A3A06;\n}\n\n.chipInactive {\n    background: var(--color-neutral-100);\n    color: var(--color-neutral-600);\n    font-weight: 600;\n}\n\n.chipDot {\n    width: calc(var(--px) * 8);\n    height: calc(var(--px) * 8);\n    border-radius: 50%;\n    background: var(--home-color-orange);\n}\n\n.plot {\n    position: relative;\n    width: calc(var(--px) * 300);\n    height: calc(var(--px) * 150);\n}\n\n.svg {\n    position: absolute;\n    inset: 0;\n    display: block;\n    width: calc(var(--px) * 300);\n    height: calc(var(--px) * 150);\n}\n\n.axisLabel {\n    font-size: calc(var(--px) * 10);\n    font-weight: 600;\n}\n\n.revealRect {\n    transform: scaleX(1);\n    transform-origin: 80px 0;\n}\n\n.revealRect.animated {\n    animation: reveal 8s linear infinite;\n}\n\n@keyframes reveal {\n    from {\n        transform: scaleX(0);\n    }\n    to {\n        transform: scaleX(1);\n    }\n}\n\n.radiusGroup {\n    transform-origin: 36px 75px;\n    transform: rotate(0deg);\n}\n\n.radiusGroup.animated {\n    animation: spin 8s linear infinite reverse;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.tracerTrack {\n    position: absolute;\n    left: 0;\n    top: calc(var(--px) * 75);\n    width: calc(var(--px) * 300);\n    height: 0;\n    transform: translateY(0);\n}\n\n.tracerTrack.animated {\n    animation: sy 8s infinite;\n}\n\n@keyframes sy {\n    0% {\n        transform: translateY(0);\n        animation-timing-function: cubic-bezier(.61, 1, .88, 1);\n    }\n    25% {\n        transform: translateY(calc(var(--px) * -30));\n        animation-timing-function: cubic-bezier(.12, 0, .39, 0);\n    }\n    50% {\n        transform: translateY(0);\n        animation-timing-function: cubic-bezier(.61, 1, .88, 1);\n    }\n    75% {\n        transform: translateY(calc(var(--px) * 30));\n        animation-timing-function: cubic-bezier(.12, 0, .39, 0);\n    }\n    100% {\n        transform: translateY(0);\n    }\n}\n\n.guide {\n    position: absolute;\n    left: calc(var(--px) * 36);\n    top: -1px;\n    width: calc(var(--px) * 254);\n    border-top: 1.5px dashed var(--color-neutral-400);\n}\n\n.tracerDot {\n    position: absolute;\n    left: calc(var(--px) * -6);\n    top: calc(var(--px) * -6);\n    width: calc(var(--px) * 12);\n    height: calc(var(--px) * 12);\n    border-radius: 50%;\n    background: var(--home-color-orange);\n    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);\n    transform: translateX(calc(var(--px) * 290));\n}\n\n.tracerDot.animated {\n    animation: sx 8s linear infinite;\n}\n\n@keyframes sx {\n    from {\n        transform: translateX(calc(var(--px) * 80));\n    }\n    to {\n        transform: translateX(calc(var(--px) * 290));\n    }\n}\n\n.caption {\n    font-size: calc(var(--px) * 13);\n    font-weight: 600;\n    color: var(--color-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chips": `chips__TrigWidget-module--dOdUn`,
	"chipActive": `chipActive__TrigWidget-module--GidfU`,
	"chipInactive": `chipInactive__TrigWidget-module--s_Bxf`,
	"chipDot": `chipDot__TrigWidget-module--rKm2d`,
	"plot": `plot__TrigWidget-module--bbg3Z`,
	"svg": `svg__TrigWidget-module--yKN3B`,
	"axisLabel": `axisLabel__TrigWidget-module--R5tZg`,
	"revealRect": `revealRect__TrigWidget-module--yFikt`,
	"animated": `animated__TrigWidget-module--hB9KE`,
	"reveal": `reveal__TrigWidget-module--E9y0L`,
	"radiusGroup": `radiusGroup__TrigWidget-module--V6dZc`,
	"spin": `spin__TrigWidget-module--bc_eG`,
	"tracerTrack": `tracerTrack__TrigWidget-module--tqAir`,
	"sy": `sy__TrigWidget-module--sfTEK`,
	"guide": `guide__TrigWidget-module--lbO7a`,
	"tracerDot": `tracerDot__TrigWidget-module--PxJef`,
	"sx": `sx__TrigWidget-module--KVGLg`,
	"caption": `caption__TrigWidget-module--IX_pt`
};
export default ___CSS_LOADER_EXPORT___;
